// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PKXD","placeholdersHeader":"styles_placeholdersHeader__106kY","editorStyle":"styles_editorStyle__1eFRB","placeholdersBox":"styles_placeholdersBox__1D66k"};